export function queryString(
  obj: string | Record<string, any>,
  req?: any,
): string {
  let search
  if (req) {
    search = req.url?.split('?')[1] || ''
  } else if (import.meta.client) {
    search = location.search
  }

  const urlSearchParams = new URLSearchParams(search)

  if (typeof obj === 'string') {
    // Remove leading question mark or ampersand, if present
    const stringParams = obj.replace(/^[?&]/, '')
    stringParams.split('&').forEach((param) => {
      const [key, value] = param.split('=')
      urlSearchParams.set(key, decodeURIComponent(value || ''))
    })
  } else if (typeof obj === 'object') {
    for (const [key, value] of Object.entries(obj)) {
      urlSearchParams.set(key, String(value))
    }
  }

  return urlSearchParams.toString()
}

export function silentlyUpdateQueryString(
  obj: string | Record<string, any>,
  req: any,
) {
  const path = location.href.split('?')[0]
  const qs = queryString(obj, req)
  history.replaceState({}, '', `${path || ''}?${qs}`)
}
